export default __webpack_public_path__ + "static/media/vimeo.8263c429.svg";